import { TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'
import { computed, inject, toValue } from 'vue'
import { useRoute } from 'vue-router'

export function useSalesChannel (channels = [], order = null) {
  const route = useRoute()

  const isConsumerAppMode = inject('isConsumerAppMode')
  const isRegisterAppMode = inject('isRegisterAppMode')
  const isMobileRegisterAppMode = inject('isMobileRegisterAppMode')?.()
  const isKioskAppMode = inject('isKioskAppMode')

  function computeSalesChannel (channels, order = null) {
    channels = toValue(channels)
    order = toValue(order)

    if (isConsumerAppMode) {
      if (_.includes(channels, TYPES.QR_CODE) && !_.isNil(route.query['delivery-location'])) return TYPES.QR_CODE

      if (_.includes(channels, TYPES.MOBILE_APP) && window._capacitorNative) return TYPES.MOBILE_APP

      return TYPES.WEBSITE
    } else if (isKioskAppMode) {
      return TYPES.KIOSK
    } else if (isRegisterAppMode) {
      if (_.includes(channels, TYPES.PHONE) && order?.phoneOrder) return TYPES.PHONE

      if (_.includes(channels, TYPES.HANDHELD) && isMobileRegisterAppMode) return TYPES.HANDHELD

      return TYPES.REGISTER
    }

    return null
  }

  const salesChannel = computed(() => computeSalesChannel(channels, order))

  return {
    computeSalesChannel,
    salesChannel
  }
}
